<template lang="html">
  <section class="app-create-project">
    <p class="text-success" v-if="messageSubmission">
      <strong>{{ messageSubmission }}</strong>
    </p>
    <form @submit.prevent="onSubmit" class=" text-left" :class="$v.dataForm.$invalid ? '':'was-validated'">
      <div class="form-group d-flex">
        <label for="projectTitle" class="w-25 align-self-center">* Title :</label>
        <div class="w-100">
          <input @blur="$v.dataForm.projectTitle.$touch()" v-model="dataForm.projectTitle"
                 :class="$v.dataForm.projectTitle.$error ? 'is-invalid': ''" id="projectTitle"
                 type="text" class="form-control">
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.projectTitle.required">Please enter the title of the project !</div>
            <div v-if="!$v.dataForm.projectTitle.minLength">
              Project title is too short and may not be correct !
              Enter at least {{$v.dataForm.projectTitle.$params.minLength.min}} letters.
            </div>
            <div v-if="!$v.dataForm.projectTitle.maxLength">
              Project title is too long ({{$v.dataForm.projectTitle.$params.maxLength.max}} letters) ! Try to make it short !
            </div>
          </div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="projectTypeId" class="w-25 align-self-center">* Type of project :</label>
        <div class="w-100">
          <select @blur="$v.dataForm.projectTypeId.$touch()" v-model="dataForm.projectTypeId"
                  :class="$v.dataForm.projectTypeId.$error ? 'is-invalid': ''" id="projectTypeId"
                  class="custom-select">
            <option :value="projects_type.project_type_id" :key="projects_type.project_type_id" class="text-capitalize"
                    v-for="projects_type of getProjectsTypes">{{ projects_type.type }}</option>
          </select>
          <div class="invalid-feedback">Please select a category of your project !</div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="projectLinkProject" class="w-25 align-self-center">* Link Project :</label>
        <div class="w-100">
          <input :class="$v.dataForm.projectLinkProject.$error ? 'is-invalid': ''"
                 @blur="$v.dataForm.projectLinkProject.$touch()" v-model="dataForm.projectLinkProject"
                 type="url" class="form-control" id="projectLinkProject">
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.projectLinkProject.required">Please provide a link of your project !</div>
            <div v-if="!$v.dataForm.projectLinkProject.url">Please enter a valid link of your project !</div>
            <div v-if="!$v.dataForm.projectLinkProject.maxLength">
              The link is too long (more than {{$v.dataForm.projectLinkProject.$params.maxLength.max}} characters) !
              Please try to shorten it !
            </div>
          </div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="projectLinkOverview" class="w-25 align-self-center">* Link Overview :</label>
        <div class="w-100">
          <input :class="$v.dataForm.projectLinkOverview.$error ? 'is-invalid': ''"
                 @blur="$v.dataForm.projectLinkOverview.$touch()" v-model="dataForm.projectLinkOverview"
                 type="text" class="form-control" id="projectLinkOverview">
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.projectLinkProject.required">Please provide a link of the overview of your project !</div>
            <div v-if="!$v.dataForm.projectLinkOverview.url">Please enter a valid link of the overview of your project !</div>
            <div v-if="!$v.dataForm.projectLinkOverview.maxLength">
              The link is too long (more than {{$v.dataForm.projectLinkOverview.$params.maxLength.max}} characters) !
              Please try to shorten it !
            </div>
          </div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="projectDescription" class="w-25 align-self-center">* Description :</label>
        <div class="w-100">
          <textarea :class="$v.dataForm.projectDescription.$error ? 'is-invalid': ''"
                    @blur="$v.dataForm.projectDescription.$touch()" v-model="dataForm.projectDescription"
                    class="form-control" id="projectDescription" placeholder="Enter text here...">
          </textarea>
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.projectDescription.required">Please enter a description of your project !</div>
            <div v-if="!$v.dataForm.projectDescription.minLength">
              The Description is too short ! Try to enter more than
              {{$v.dataForm.projectDescription.$params.minLength.min}} characters !
            </div>
          </div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="projectTeammates" class="w-25 align-self-center">Teammates :</label>
        <div class="w-100">
          <input :class="$v.dataForm.projectTeammates.$error ? 'is-invalid': ''"
                 @blur="$v.dataForm.projectTeammates.$touch()" v-model="dataForm.projectTeammates"
                 type="text" class="form-control" id="projectTeammates">
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.projectTeammates.minLength">
              Please make sure you enter valid full name(s) of your teammates !
              <br>This field can't contain ({{$v.dataForm.projectTeammates.$params.minLength.min}}) characters or less !
            </div>
            <div v-if="!$v.dataForm.projectTeammates.maxLength">
              You have exceeded the number of characters ({{$v.dataForm.projectTeammates.$params.maxLength.max}})
              allowed for this field !
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4 mb-4 text-center">
        <button :class="$v.dataForm.$invalid ? 'cursor-pointer-disabled':''"
                type="submit" class="btn btn-success" :disabled="$v.dataForm.$invalid">
          Submit
        </button>
        <button type="button" class="btn btn-danger ml-3">Reset</button>
      </div>
    </form>
  </section>
</template>

<script lang="js">
import {uuid} from 'vue-uuid'
import {mapGetters, mapActions} from "vuex";
import {FORM_PROJECTS_VALIDATIONS} from '../../validations/formProjects'
export default {
  name: 'CreateProject',
  props: [],
  mounted () {},
  created () {
    this.axiosGet({component: 'projects_types', state: 'listProjectsTypes'})
  },
  validations: FORM_PROJECTS_VALIDATIONS,
  data () {
    return {
      dataForm : {
        projectId: uuid.v4(),
        projectTypeId: undefined,
        projectTitle: undefined,
        projectLinkProject: undefined,
        projectLinkOverview: undefined,
        projectDescription: undefined,
        projectTeammates: undefined
      },
      messageSubmission: ""
    }
  },
  methods: {
    ...mapActions([
      'createData',
      'axiosGet'
    ]),
    onSubmit () {
      const formData = {
        project_id: this.dataForm.projectId,
        project_type_id: this.dataForm.projectTypeId,
        title: this.dataForm.projectTitle,
        link_project: this.dataForm.projectLinkProject,
        link_overview: this.dataForm.projectLinkOverview,
        description: this.dataForm.projectDescription,
        teammates: this.dataForm.projectTeammates
      };
      this.dataForm.projectId = uuid.v4();
      this.createData(formData)
        .then(data => {
          this.messageSubmission = data;
          setTimeout( () => {
            this.messageSubmission = '';
            this.resetForm();
          }, 5000);
        })
        .catch(data => console.log(data))
    },
    resetForm () {
      this.dataForm.projectId = uuid.v4();
      this.dataForm.projectTypeId = undefined;
      this.dataForm.projectTitle = undefined;
      this.dataForm.projectLinkProject = undefined;
      this.dataForm.projectLinkOverview = undefined;
      this.dataForm.projectDescription = undefined;
      this.dataForm.projectTeammates = undefined;
    }
  },
  computed: {
    ...mapGetters([
      'getProjectsTypes'
    ])
  }
}
</script>

<style scoped lang="scss">
  .app-create-project {}
</style>



// WEBPACK FOOTER //
// src/components/projects/CreateProject.vue